/**
 * TrainerEmargements — list of MY upcoming/recent sessions with a "Compléter
 * l'émargement" CTA on each. Per user choice 2a, the trainer can write.
 *
 * For now this is a simple list. Wiring the existing admin emargement signing
 * UI is out of scope for V100 — we just open the admin page in a new tab.
 */
import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import { Loader2, ClipboardCheck, ArrowUpRight } from 'lucide-react';

export default function TrainerEmargements() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get('/me/trainer/sessions').then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const today = new Date().toISOString().slice(0, 10);
  const candidates = (items || []).filter((s) => (s.endDate || s.startDate || '') >= today || (s.status || '').toLowerCase().includes('cours'));

  return (
    <div className="space-y-4" data-testid="trainer-emargements">
      <h1 className="text-[22px] font-bold text-[#1A1B2E]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Mes émargements</h1>
      <p className="text-[12.5px] text-[#6B6C85]">Sessions à émarger ou en cours d'émargement.</p>

      {items === null && <div className="flex items-center justify-center py-12"><Loader2 className="w-5 h-5 animate-spin text-[#4F46E5]" /></div>}
      {items && candidates.length === 0 && (
        <div className="soft-card p-6 text-center text-[12.5px] italic text-[#8E8FA5]">
          Aucun émargement en attente. Bonne journée !
        </div>
      )}
      {items && candidates.map((s) => (
        <div key={s.id} className="soft-card p-4 flex items-center gap-3" data-testid={`trainer-emargement-${s.id}`}>
          <div className="w-10 h-10 rounded-xl bg-[#EEF2FF] text-[#4F46E5] flex items-center justify-center shrink-0">
            <ClipboardCheck className="w-4 h-4" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[13.5px] font-semibold text-[#1A1B2E] truncate">{s.title || s.program || 'Session'}</div>
            <div className="text-[11.5px] text-[#6B6C85] truncate">
              {s.startDate}{s.endDate && s.endDate !== s.startDate ? ` → ${s.endDate}` : ''} {s.location ? `· ${s.location}` : ''}
            </div>
          </div>
          <a
            href={`/app/emargements?sessionId=${encodeURIComponent(s.id)}`}
            className="h-9 px-3 rounded-lg bg-[#4F46E5] text-white text-[12px] font-semibold inline-flex items-center gap-1 hover:bg-[#6B47FA] transition-colors"
            data-testid={`trainer-emargement-open-${s.id}`}
          >
            Émarger <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>
      ))}
    </div>
  );
}
